<template>
  <div class="panel-body">
    <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <vue-form-generator :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
    {{this.msg_conferma}}
  </div>
</template>

<script>
import axios from 'axios'
// @ is an alias to /src
export default {
  name: 'distribuzione',
  components: {
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      config: {headers: { Authorization: 'bearer ' + localStorage.getItem('access_token') }},
      loading: false,
      msg_conferma: '',
      model: {
        batch_code: [],
        mold: null,
        delivery:''
        },
      schema: {
        fields: [
          {
            type: 'select',
            inputType: 'number',
            label: 'Codice del lotto',
            model: 'batch_code',
            values: [],
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Conferma selezione',
            validateBeforeSubmit: true,
            onSubmit: this.loadData,
            disabled: false
          },
          {
            type: 'checkbox',
            label: 'Lieviti/Muffe',
            model: 'mold',
            textalign: "Center", 
            default: false,
            disabled: false
          },
          {
            type: 'input',
            inputType: 'date',
            label: 'Data uscita',
            model: 'delivery',
            placeholder: 'Inserire data uscita',
            disabled: false,
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Invia',
            validateBeforeSubmit: true,
            onSubmit: this.saveForm,
            disabled: false
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  mounted () {
      this.getProducts()
  },
  methods: {
      loadData: function (batch_id) {
      axios.get(this.apiUrl + 'products/' + batch_id)
      .then(response => {
      this.model.delivery = response.data.delivery
      this.model.mold = response.data.mold
      })
      },
      saveForm: function (model) {
        this.loading = true
        this.$store.dispatch('update_distribuzione', model)
        var delivery = new Date(this.model.delivery)
        var month = ("0" + (delivery.getMonth() + 1)).slice(-2)
        var day = ("0" + (delivery.getDate())).slice(-2)
        var year = (delivery.getFullYear())
        let delivery_formatted = year + "-" + month + "-" + day + " 17:00:00"

      // eslint-disable-next-line
      //console.log(delivery_formatted)
      // eslint-disable-next-line
      //console.log(this.model.mold)
    axios.put(this.apiUrl + 'products/'+ this.model.batch_code, 
    {
    "delivery": delivery_formatted,
    "mold": this.model.mold
    }, this.config).then(() => {
      // eslint-disable-next-line
      // console.log(response.data)
      this.msg_conferma = 'Informazioni registrate correttamente'
      this.schema.fields[3].disabled = true
    }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      this.msg_conferma = 'Si è verificato un errore, riprova'
      }).finally(() => {
      this.loading = false
  });
    },
    getProducts: function () {
    this.loading = true
    axios.get(this.apiUrl + 'products?_sort=created_at:DESC')
      .then(response => {
      let batch_values = []
      for (let r of response.data) {
      batch_values.push(
        {"name": r.code,
        "id" : r.id
        }
      )
      }
      // eslint-disable-next-line
      // console.log("Getting data:", batch_values)
      this.$store.commit('BATCHLIST_FETCH', batch_values)
      this.schema.fields[0].values = batch_values
      this.loading = false
      })
    }
}
}
</script>

<style>

</style>
